module.exports = __webpack_public_path__ + "img/DOGER.9906fdea.svg";